import api from '../../services/api'

export const imageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
export const imageEndpoint = (conversation, image) => `chat/conversations/${conversation}/images/${image}`
export function releaseImage(draft) {
  draft.controller?.abort()
  if (draft.url) URL.revokeObjectURL(draft.url)
}
export function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url; link.download = name || 'image'; link.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
export async function imageBlob(conversation, image, preview, signal) {
  const { data } = await api.get(`${imageEndpoint(conversation, image)}/content`, { params: { preview: preview ? 1 : 0 }, responseType: 'blob', signal })
  return data
}
